import { useState, useEffect } from 'react';
import { useConfig } from '@lore/config';
import { useClientAsyncInit } from '@statsig/react-bindings';
import { browserName, osName } from 'react-device-detect';

function isLinux(name) {
  const LinuxOsNames = [
    'Arch', 'CentOS', 'Fedora', 'Debian', 'Deepin', 'Gentoo', 'Joli', 'Linpus',
    'Linspire', 'Linux', 'Maemo', 'Mageia', 'Mandriva', 'Manjaro', 'MeeGo',
    'Mint', 'PCLinuxOS', 'Raspbian', 'RedHat', 'Sabayon', 'Sailfish',
    'Slackware', 'SUSE', 'Tizen', 'Ubuntu', 'VectorLinux', 'Zenwalk',
    'elementary OS'
  ];
  return LinuxOsNames.indexOf(name) !== -1;
}

export default function useFeatureFlags(currentUser) {
  const config = useConfig();
  const [isUserReady, setIsUserReady] = useState(false);

  const { client, isLoading: isFetching } = useClientAsyncInit(
    config.statsig.apiKey,
    {
      userID: currentUser?.data?.id ?? 'unauthenticated',
      email: currentUser?.data?.email,
      browserName,
      custom: { os_name: isLinux(osName) ? 'Linux' : osName }
    },
    { environment: { tier: config.statsig.environment } }
  );

  useEffect(() => {
    if (!client) return;
    if (!currentUser?.data?.id) {
      setIsUserReady(true);
      return;
    }
    client.updateUserAsync({
      userID: currentUser.data.id,
      email: currentUser.data.email,
      browserName,
      custom: { os_name: isLinux(osName) ? 'Linux' : osName }
    })
      .then(() => setIsUserReady(true))
      .catch(() => {
        console.error('statsig user update failed')
        setIsUserReady(true)
      });
  }, [client, currentUser?.data?.id, currentUser?.data?.email]);

  const getStreamlinedAccountFlowEnabled = () => {
    if (isFetching || !client || !isUserReady) return false;
    return client.checkGate('streamlined_account_creation');
  };
  const getFellowshipCTA = () => {
    if (isFetching || !client || !isUserReady) return false;
    return client.checkGate('cta_fellowship_training');
  };
  const getFeedbackCTA = () => {
    if (isFetching || !client || !isUserReady) return false;
    return client.checkGate('cta_feedback_survey');
  };
  const getLowerNetworkBarriersStewards = () => {
    if (isFetching || !client || !isUserReady) return false;
    return client.checkGate('lower_network_barriers_for_stewards');
  }

  return {
    isFetching: isFetching || !isUserReady,
    client,
    getStreamlinedAccountFlowEnabled,
    getFellowshipCTA,
    getFeedbackCTA,
    getLowerNetworkBarriersStewards
  };
}
